const SecondaryButton = ({ title, handler = () => {}, css, show = false }) => {
  return (
    <div className="relative w-full">
      <button className={`bg-white border border-[#F2F2F2] rounded-[5px] text-Black text-sm font-medium shadow-sm ${css}`} onClick={handler}>
        {title}
      </button>
      {show && (
        <div className="bg-[#FF3E46] rounded-full w-4 h-4 absolute top-2 right-[15%] lg:right-[19%] items-center flex justify-center text-white text-[9px] p-1 font-semibold">
          12
        </div>
      )}
    </div>
  );
};

export default SecondaryButton;
